import { render } from "./ProjectsMain.vue?vue&type=template&id=64d2d3c0"
import script from "./ProjectsMain.vue?vue&type=script&lang=js"
export * from "./ProjectsMain.vue?vue&type=script&lang=js"

import "./ProjectsMain.vue?vue&type=style&index=0&id=64d2d3c0&lang=css"

import exportComponent from "D:\\eestec sajt trenutni\\eestec.etf.rs\\front-end\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__